<template>
    <div >
      <DxPopup
        :visible="isReportVisible"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-close-button="true"
        :show-title="true"
        :hide-on-parent-scroll="true"
        :title="$t('treatmentplan.ObjectiveReview')"
        @hidden="onHiddenReport"
        :resize-enabled="true"
        shading-color="rgba(0, 0, 0, 0.5)"
        height="94vh"
        width="97vw"
        @showing="onShowing"
      >
        <ReportViewer
          ref="objectiveReview"
          :ReportName="'ObjectiveReview'"
          :ReportTitle="$t('treatmentplan.ObjectiveReview')"
          :IsAnAPIReport="true"
        />
    </DxPopup>
    </div>
</template>

<script>
    import Vue from 'vue'
    import { DxPopup } from 'devextreme-vue/popup';
    import ShowMessage from '@/components/messages/ShowMessage.js'
    // import Utils from '../../../common/utils'

    export default Vue.extend({
        name: "objectiveReviewRep",
        mixins: [ ShowMessage ],
        components: { DxPopup },
        props: {
          closeWindow: Function,
          objRecId: String,
          recNo: String
        },
        data() {
            return {
                isParamVisible: true,
                isReportVisible: false,
                reportParams: [],
            }
        },
        methods: {

            onShowing(e) {
              let contentElement = e.component.content();
              let titleElement = e.component._$title[0]
              contentElement.style.padding = '0px';
              titleElement.style.padding = '0px 20px'
            },

            onHiddenReport() {
              this.isReportVisible = false
              this.closeWindow()
            },

            onClickClose() {
              this.closeWindow()
              this.isParamVisible = false;
            },

            onClickShowReport() {
              this.isParamVisible = false

              this.reportParams = []
              this.reportParams.push({ paramName: 'objRecId', paramValue: this.objRecId})
              this.reportParams.push({ paramName: 'recNo', paramValue: this.recNo})
            
              this.isReportVisible = true
              this.$refs.objectiveReview.buildDocument(this.reportParams)
            }
        },
        
        mounted () {
           if (this.objRecId)
              this.onClickShowReport()
        },
    })
</script>
<style>
  .dxrd-report-preview-holder {  
      height: 94% !important; 
  } 
</style>
